import { BaseIntegration, BaseIntegrationData, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationCarlsJrSettingsData } from './Data';

export interface IntegrationCarlsJrData extends BaseIntegrationData {
  settings: null | IntegrationCarlsJrSettingsData;
}

export interface IntegrationCarlsJrState extends BaseIntegrationState {
  type: string;
}

export class IntegrationCarlsJrModel extends BaseIntegration<IntegrationCarlsJrData, IntegrationCarlsJrState> {
  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/carlsjr/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
